<template>
    <div>
      <h2>홈화면의 학생등록 <br/>
          (입반/전반/입반취소/전반취소)</h2>
      <section>
        <div class="p-relative section_0" id="register">
            <div class="ft-b">1)  학생등록</div>
            <div class="p-relative section_1">
                -   Tens에듀의 홈화면에서 학생정보를 입력 후
            </div>
            <div class="p-relative section_1">
                -   입력버튼을 클릭하여 저장합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_register.jpg" /></div>
            </div>
            <div class="p-relative section_2">
                학교, 학년, 집주소, 입학동기 등의 추가 정보를 입력할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                학생상태는 학생 정보 입력시에의 정보(대기,재원)에 의해서 결정됩니다.
            </div>
        </div>
        <p></p>

        <div class="p-relative section_0" id="enter_class">
            <div class="ft-b">2)  반에 학생 등록 (입반)</div>
            
            <div class="p-relative section_2">
                반관리 메뉴에서 반을 생성하였다면, 학생을 원하는 반에 등록할 수 있습니다.
                <div><img src="@/assets/aca/manual/home/home_register_button.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   홈화면에서 “입반”버튼을 클릭하여 반에 학생을 등록합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_enter_class.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   “입반 다이알로그”에서 반형태를 설정하고 반을 선택하고 입반일을 입력합니다.
            </div>
            <div class="p-relative section_1">
                -   “입반”버튼을 클릭하면 반에 입반이 이루어집니다.
            </div>

        </div>

        <p></p>

        <div class="p-relative section_0" id="enter_cancel">
            <div class="ft-b">3)  입반 취소</div>

            <div class="p-relative section_2">
                만약, 잘못하여 입반을 시켰다면, “입반취소” 버튼으로 입반을 취소시킬 수 있습니다.
            </div>
            <div class="p-relative section_1">
                -   홈화면에서 “입반취소”버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_enter_cancel.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   “입반취소 다이알로그”에서 반을 선택하고 “입반취소”버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_enter_cancel_modal.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   입반취소의 명령은 다음과 같은 상황에서는 입반취소가 되지 않습니다.
            </div>

            <div class="p-relative section_2 box examples">
                퇴반이 이루어져 수강중이 아닌 경우<br/>
                전반으로 반에 들어간 경우 (전반은 전반취소를 사용합니다.)<br/>
                입반하고 수강료 납입이 이루어진 경우<br/>
            </div>
            
            <div class="p-relative section_2">
                이 경우는 자동으로 상황을 판단할 수 없는 경우입니다. 따라서 수동으로 관리자가 판단하여 처리하여야 합니다.
            </div>
            <p></p>
            <div class="p-relative section_2">
                예를 들어 잘못하여 <span class="bg-yellow-13">A반으로 입반하여 이미 수강료가 납부된 상황</span>인데, B반으로 바꾸고 싶다면, 입반취소는 불가능합니다. 이와 같은 경우는 A반 수강료를 환불시키고, 학생을 A반에서 퇴반시킨 후 다시 B반으로 입반합니다. 그리고나서 B반에서 수강료 발생후 납입하도록 합니다. 이때 반에 따라 수강료차이가 발생할 수 있으므로, 이에 대한 판단은 관리자가 해야 합니다.
            </div>

        </div>

        <p></p>
        <div class="p-relative section_0" id="move_class">
            <div class="ft-b">4)  다른 반으로 이동 (전반하기)</div>

            <div class="p-relative section_2">
                전반의 경우는 특수한 경우로 활용합니다.
            </div>
            <p></p>
            <div class="p-relative section_2">
                예를들어 A반에 수강중인 학생이 B반으로 과정 중간에 바꾸려고 할 때 사용합니다. 이러한 이유는 선생님과 안맞아서 일 수도 있고, 친구 때문에 이동할 수도 있습니다. 이와 같이 과정 중간에 바꾸는 경우 전반을 사용합니다.
            </div>
            <p></p>

            <div class="p-relative section_1">
                -   홈화면에서 “전반”버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_move_button.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   “전반 다이알로그”에서 어느반에서 어느반으로 이동하는지 선택해주어야 합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_move_modal.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   예를 들어 A반에서 B반으로 이동한다고 한다면,
            </div>
            <div class="p-relative section_2">
                순서는 A반선택, B반선택, 전반일 입력 후 “전반”버튼을 클릭하면 전반이 진행됩니다.
            </div>

            <div class="p-relative section_1">
                -   전반의 경우는 특수한 상황이므로 다음과 같은 경우는 전반이 이루어지지 않습니다.
            </div>
            <div class="p-relative section_2 box examples" >
                A반과 B반이 같은 경우 (잘못된 명령임)<br/>
                B반이 종강된 반인 경우 (잘못된 명령임)<br/>
                A반에 수강료 납입기록이 있는 경우 (수강료 문제로 수동처리 해야함)<br/>
                만약, B반에 수강했던 기록이 있다면, 전반일은 이전의 B반 퇴반일 이후이어야 전반이 가능함.<br/>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="move_cancel">
            <div class="ft-b">5)  전반취소</div>
            
            <div class="p-relative section_2">
                만약, 잘못하여 전반을 시켰다면, “전반취소” 버튼으로 전반을 취소시킬 수 있습니다
            </div>
            <p></p>
            <div class="p-relative section_1">
                -   홈화면에서 “전반취소”버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_move_cancel.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   “전반취소 다이알로그”에서 반을 선택하고 “전반취소”버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_move_cancel_modal.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   전반취소의 명령은 다음과 같은 상황에서는 전반취소가 되지 않습니다.
            </div>
            <div class="p-relative section_2 box examples">
                퇴반이 되어서 수강중이 아닌 경우<br/>
                전반으로 반에 들어간 경우 (입반은 입반취소를 사용합니다.)<br/>
                전반하고 수강료 납입이 이루어진 경우<br/>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="make_billing">
            <div class="ft-b">6)  수강료 발생</div>
            
            <div class="p-relative section_1">
                -   홈화면에서 “수강료발생”버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_make_billing.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   학생을 입반시켰다면, 수동으로 수강료를 발생시켜야 합니다. 자동발생은 다음 달부터 청구되므로, 이번 달의 수강료를 수동으로 발생시켜야 합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_make_billing_modal.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   수강료는 기본적으로 매월 1일을 납입기한으로 정합니다. 
            </div>
            <div class="p-relative section_2">
                예를들어, 학생이 이번 달의 중간에 들어왔다면 수강료의 1/2만을 청구해야 합니다.
            </div>
            <div class="p-relative section_2">
                이와 같은 경우는 수강료를 조정해서 청구해야 합니다.
            </div>
            <p></p>
            <div class="p-relative section_1">
                -   경우에 따라서는 다음 달 수강료를 미리 청구하는 경우도 있습니다. 
            </div>
            <div class="p-relative section_2">
                예를 들어 학생이 여행을 간다고 하고 다음 달의 1/2을 빠진다고 하면, 다음 달의 수강료를 미리 발생시켜 놓을 수 있습니다. 다음 달의 수강료가 발생된 적이 있다면 자동발생에서는 제외됩니다.
            </div>
            <div class="p-relative section_1" id="change_billing">
                -   변경된 금액으로 수강료 발생하는 경우
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_change_billing_modal.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="make_textbook_billing">
            <div class="ft-b">7)  교재판매</div>
            
            <div class="p-relative section_1">
                -   홈화면에서 “교재판매”버튼을 클릭합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_textbook_billing.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   “교재판매다이알로그”에서 반형태, 교재선택, 할인선택, 납입기한을 입력하고 “교재판매”버튼을 클릭하여 학생에게 교재판매를 생성합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/home_textbook_billing_modal.jpg" /></div>
            </div>
        </div>

      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '학생등록', link: '#register' },
                { label: '입반', link: '#enter_class' },
                { label: '입반 취소', link: '#enter_cancel' },
                { label: '전반', link: '#move_class' },
                { label: '전반 취소', link: '#move_cancel' },
                { label: '수강료 발생', link: '#make_billing' },
                { label: '변경된 금액으로 수강료 발생', link: '#change_billing' },
                { label: '교재판매', link: '#make_textbook_billing' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


<style scope>
.section {
  width: 400px; 
  padding-left: 32px; 
  text-indent: -16px;
}
</style>